import { components } from '../../tokens/components/bluestone/TR';
import { createTheme } from '../../tokens/createTheme';
import type { DeprecatedTheme } from '../types';
import colorsTR from './colors/base/TR';
import alertTokens from './components/alert.tokens';
import createCalendarTokens from './components/calendar.tokens';
import checkboxTokens from './components/checkbox.tokens';
import drawerHeaderTokens from './components/drawerHeader.tokens';
import inputTokens from './components/input.tokens';
import sliderTokens from './components/slider.tokens';
import { ED } from './ED';

const colorsBrand = {
  0: '#FE7100', // brandPrimary.0 - does not match primary.x token
  1: '#E66700', // brandPrimary.1 - does not match primary.x token
  2: '#BE5400', // brandPrimary.1 - does not match primary.x token
};
const brandSecondary = '#5C9FAB';

const { colors: colorsED, borders, space, fontSizes, sizes, lineHeights } = ED;

const colors = {
  ...colorsED,
  ...colorsTR,
  brandPrimary: colorsBrand,
};
const fontSizeBody = fontSizes.body;

const drawerHeader = drawerHeaderTokens({
  colorsBrand,
  colors,
  borders,
  space,
});
const slider = sliderTokens({
  colors,
  colorsBrand,
  sizes,
  space,
  fontSizeBody,
});
const checkbox = checkboxTokens({
  borders,
  colors,
  colorsBrand,
  space,
  lineHeights,
  fontSizeBody,
});
const input = inputTokens({
  fontSizes,
  lineHeights,
  colors,
});
const alert = alertTokens({ colors, borders });
const calendar = createCalendarTokens({ colors });

const TR: DeprecatedTheme = createTheme(
  'blueStone',
  {
    ...ED,
    colors: {
      ...colors,
      text: colors,
      drawerHeader: drawerHeader.colors,
      slider: slider.colors,
      checkbox: checkbox.colors,
      brandedProgressBar: brandSecondary,
      decorationLine: {
        ...colors.decorationLine,
        default: brandSecondary,
      },
      input: input.colors,
      alert: alert.colors,
      calendar: calendar.colors,
    },
    borders: {
      ...ED.borders,
      alert: alert.borders,
    },
  },
  components
);

export default TR;
